import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import styles from "../TransparentDrawer.module.scss";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useParams } from "react-router-dom";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function GetReceipt() {
  const { t } = useTranslation();
  const { restaurantId } = useParams();
  const { handleNavigate } = useOnClickFunctions();
  const { tableId } = useVenuesDataStore();

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <Button
        onClick={() => {
          handleNavigate(`/restaurants/${restaurantId}/receipt-sent`);
        }}
        label={t("transparentDrawer.button.sendReceipt")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
      <Button
        onClick={() => {
          handleNavigate(`/restaurants/${restaurantId}/tables/${tableId}`);
        }}
        label={t("transparentDrawer.button.cancel")}
        variant="outlined"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default GetReceipt;
